// @ts-strict-ignore
import React from 'react'
import { View, Linking, Image, Platform } from 'react-native'
import styled from 'styled-components/native'

import Typography from 'APP/Converse/Typography'
import Button from 'APP/Converse/Button'

import I18n from 'APP/I18n'
import Config from 'APP/Config'
import { Images } from 'APP/Themes'
import { logger } from 'APP/Lib/Datadog'

type Url = {
  [key: string]: string
}

const StyledContainer = styled(View)`
  flex: 1;
  background-color: ${({ theme }) => theme.colors.background};
  justify-content: center;
  align-items: center;
  padding-top: 0;
  gap: ${({ theme }) => theme.metrics.baseMargin}px;
  padding-horizontal: ${({ theme }) => theme.metrics.baseMargin}px;
`

const StyledImage = styled(Image)`
  resize-mode: contain;
`

const StyledTypography = styled(Typography)`
  text-align: center;
`

const gotoStore = () => {
  const store: string = Platform.OS === 'ios' ? Config.APP_STORE : Config.PLAY_STORE
  const url: Url = Platform.OS === 'ios' ? Config.APP_STORE_URL : Config.PLAY_STORE_URL
  const localizedUrl: string = url?.[I18n.baseLocale] || url?.en
  Linking.openURL(store)
    .catch((e) => {
      logger.error('Error opening link to store', { store }, e)
      Linking.openURL(localizedUrl)
    })
    .catch((e) => {
      logger.error('Error opening link to HTTPS store', { localizedUrl }, e)
    })
}

const UnsupportedVersionScreen = () => {
  return (
    <StyledContainer>
      <StyledImage source={Images.unsupportedVersionIllustration} />
      <Typography variant="h4">{I18n.t('UnsupportedVersion.title')}</Typography>
      <StyledTypography variant="bodyNormal">
        {I18n.t('UnsupportedVersion.message')}
      </StyledTypography>
      <Button
        title={I18n.t('UnsupportedVersion.gotoStore')}
        analyticsName="UnsupportedVersion.gotoStore"
        onPress={gotoStore}
        widthVariant="full"
      />
    </StyledContainer>
  )
}

export default UnsupportedVersionScreen
